window.addEventListener("turbolinks:load", () => {
	if (window.location.href.indexOf("/agents") > -1) {
		window.lockapediaForms = {    
		    updateFormContentsBtn: function (element) {
		    	var btnClicked = element.getAttribute("data-id");

		    	// Reset buttons
		    	$(".btn.btn-lg").removeClass("btn-outline-primary");
		    	$(".btn.btn-lg").addClass("btn-outline-secondary");

		    	// Set clicked button as Primary
					$('[data-id="'+btnClicked+'"]').addClass("btn-outline-primary");
					$('[data-id="'+btnClicked+'"]').removeClass("btn-outline-secondary");

					// Show relevant form
	        if (btnClicked === "llakb_form_account_verification") {
	        	$("#llakb_form_account_verification").show();
	        	$("#llakb_form_marketing_opt_out").hide();
	        } else if (btnClicked === "llakb_form_marketing_opt_out") {
	        	$("#llakb_form_account_verification").hide();
	        	$("#llakb_form_marketing_opt_out").show();
	        }
		    }
		};

	};
});
